// Clear Data

export default (data, value) => {
  Object.keys(data).forEach(key => {
    if (data[key].type === 'select') {
      if (data[key].special) {
        data[key].value = data[data[key].specialKey].value ? data[key].specialDefault : value ? data[key].items.filter(item => item.value === value[key])[0] : null
      } else {
        data[key].value = value ? data[key].items.filter(item => item.value === value[key])[0] : null
      }
    } else if (data[key].type === 'images') {
      data[key].value = value ? value[key] : []
    } else if (data[key].type === 'file') {
      data[key].value = value ? value[key] : null
    } else {
      data[key].value = value !== null ? value[key] : ''
    }
    data[key].error = value ? value[key] !== '' && value[key] !== null ? '' : null : null
  })
  return data
}
